module.exports = __webpack_public_path__ + "img/2.9ef85751.png";